import { key } from 'core-ts-types';

export class PromiseHash {

  public hash: Record<string, ng.IPromise<any>>;

  constructor() {
    this.hash = {};
  }

  public insert(p: ng.IPromise<any>, id: key): Record<string, ng.IPromise<any>> {
    this.hash[id] = p;
    return this.hash
  }

  public remove(id: key): ng.IPromise<any> {
    const p = this.hash[id];
    delete this.hash[id];
    return p;
  }
}

angular.module('capability-ng-checklist')
.factory('ngPromiseHashFactory', () => PromiseHash);



// WEBPACK FOOTER //
// ./app/lib/checklist/services/promise_hash_factory.ts